import styled from 'styled-components'
export const Button = styled.button`
  background: linear-gradient(94.08deg, #366740 -0.49%, #000 102.22%);
  border-radius: 8px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px 10px 20px;
  color: #fff;
  font-family: 'Hey-Comic', sans-serif;
`
